// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_k8-0";
export var buttonContainer = "_k8-3";
export var cancelButton = "_k8-4";
export var headerSection = "_k8-6";
export var headerTitle = "_k8-9";
export var messageSideLeft = "_k8-1";
export var messageSideRight = "_k8-2";
export var orderNumberContainer = "_k8-7";
export var orderNumberLabel = "_k8-8";
export var submitButton = "_k8-5";